module.exports = "https://r.zoocdn.com/_next/static/images/smartmap-14fed4b8f02fe7964d5ed2ddcfd2ce31.jpeg";